import type { FaireProductEntity } from "../../entity_types/product";

export const p_n786k8md5x: FaireProductEntity = {
  token: "p_n786k8md5x",
  type: "product",
  name: "Our First Christmas as Mr. and Mrs. with Year Ornament",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/b40f30154bcc6a33b401cca51ad1a0b725d45534d0364fb00ef7c39ebba3613b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/528478a490e4209f0c1becf9719c30cba29e5b1c1ae855ce3e861db913454732.jpeg",
    "https://cdn.faire.com/fastly/e27870f869da78c30dddb65dbed0ed5450d8634957496ce2efafe9f668d10b18.jpeg",
    "https://cdn.faire.com/fastly/5bcf75a0aadc848082d8f4a3179c18a9cee2835921bcc986b5ef5f746d66d83e.jpeg"
  ],
  priceDollars: 7.5,
  description: "Our Christmas ornaments make the cutest gifts for the holidays. Printed on high quality, ceramic material, these ornaments add an elegant touch to your Christmas décor! Each ornament features a unique design printed with vibrant inks. The designs are permanently pressed directly onto the Christmas ornament, creating an everlasting image that will not peel off or fade. Measures 2.75\" in diameter. Includes a complimentary gift box - perfect for gift giving!",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:44.053Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
